<template>
  <div>
    <h1 class="h3 mt-lg-3 mb-4 text-center">{{ $t("lang.label_certificate_myCerts") }}</h1>
    <search-certificates-form v-model="searchFilter"></search-certificates-form>
    <hr class="mt-6" />
    <certificate-datatable
      :items="certificates"
      :items-provider="provideCertificates"
      :table-context="tableContext"
      :additional-info="additionalInfo"
      @change="onTableContextChanged"
    ></certificate-datatable>
  </div>
</template>
<script>
import CertificateDatatable from "../../components/search/CertificateDatatable";
import SearchCertificatesForm from "../../components/search/SearchCertificatesForm";
import * as utils from "@/utils";

export default {
  name: "SearchCertificatesPage",
  components: {
    CertificateDatatable,
    SearchCertificatesForm
  },
  data() {
    return {
      certificates: [],
      additionalInfo: {
        startIndex: 0,
        endIndex: 0,
        totalRows: 0
      }
    };
  },
  computed: {
    searchFilter: {
      get: function() {
        return this.$store.getters["certificate/searchFilter"];
      },
      set: function(newValue) {
        this.add_visibleColumns(newValue);
        this.$store.commit("certificate/set_searchFilter", newValue);
      }
    },
    tableContext: {
      get: function() {
        return this.$store.getters["certificate/tableContext"];
      },
      set: function(newValue) {
        this.$store.commit("certificate/set_tableContext", newValue);
      }
    }
  },
  methods: {
    /**
     * Called whenever the table component's has submitted changes (e.g. pagination/sort). Should trigger a new search.
     */
    onTableContextChanged(newTableContext) {
      // Commit to store. This will start a new search indirectly.
      const normalizedNewTableContext = utils.normalizeTableContext(newTableContext);
      this.$store.commit("certificate/set_tableContext", normalizedNewTableContext);
    },
    provideCertificates() {
      // Prepare request
      const pageable = utils.buildPageableFromTableContext(this.tableContext);
      const searchCriteria = utils.buildSearchCriteriaArray(this.searchFilter);

      return this.$store
        .dispatch("certificate/searchCertificates", { pageable: pageable, searchCriteria: searchCriteria })
        .then(response => {
          const data = response.data;

          this.additionalInfo = Object.assign(
            {},
            {
              startIndex: data.number * data.size + 1,
              endIndex: data.number * data.size + data.numberOfElements,
              currentRows: data.numberOfElements,
              totalRows: data.totalElements
            }
          );

          this.certificates = data.content;
          return data.content;
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", "Search failed");
        });
    },
    add_visibleColumns(newValue) {
      if (newValue.certPublicKeyAlgorithm) {
        this.$store.commit("certificate/addFromForm_columnsVisible", "certPublicKeyAlgorithm");
      }
      if (newValue.certSignatureAlgorithm) {
        this.$store.commit("certificate/addFromForm_columnsVisible", "certSignatureAlgorithm");
      }

      if (newValue.certUsageType) {
        this.$store.commit("certificate/addFromForm_columnsVisible", "certUsageType");
      }
    }
  },
  watch: {
    /**
     * Called whenever the search filter has changed. Should trigger a new search.
     */
    searchFilter: function() {
      // Start new search
      this.$root.$emit("bv::refresh::table", "table-search");
    }
  }
};
</script>
<style scoped></style>
